<template>
  <div class="container">
    <div class="c2">
      <form class="signup" @submit="sendForm">
        <!-- {{ dataForm }} -->
        <h1 class="signup1" :style="{ color: colors.userInput.text }">Registro</h1>
        <div v-for="input in dataForm" :key="input.name" class="form-input--container">
          <div
            class="form-input"
            :class="{
              'has-icon': !!input.icon,
              'inputError': errors[input.name] && errors[input.name].length
            }"
          >
            <div v-if="input.icon" class="pre-icon">
              {{ input.icon }}
            </div>
            <input
              :name="input.name"
              type="text"
              :placeholder="input.placeholder"
              class="username"
              @change="resetError(input.name)"
            />
            <div v-if="errors[input.name] && errors[input.name].length" class="error">
              <IconError width="20" height="20" />
            </div>
          </div>
          <small v-if="errors[input.name] && errors[input.name].length" class="text-error">{{
            input.validate.regex[1]
          }}</small>
        </div>
        <button class="btn" :style="{ background: colors.header.bg }">Unirme</button>
      </form>
    </div>
  </div>
</template>

<script>
import IconError from './components/IconError.vue'
import form from './assets/form.json'
import { mapActions } from 'vuex'
export default {
  components: {
    IconError
  },
  props: {
    colors: {
      type: Object,
      require: true
    }
  },
  data: () => ({
    name: '',
    email: '',
    errors: {},
    errorName: false,
    errorEmail: false
  }),
  computed: {
    dataForm() {
      return form
    }
  },
  methods: {
    ...mapActions({ init: 'INIT' }),
    sendForm(e) {
      e.preventDefault()
      const formPayload = new FormData(e.target)
      const formJson = {}

      const errors = {}
      for (const key of formPayload.keys()) {
        const inputField = this.dataForm.find((ipt) => ipt.name === key)
        //validate
        if (inputField.validate?.required) {
          if (formPayload.get(key).trim().length === 0) errors[key] = inputField.validate.required
        }
        if (Array.isArray(inputField.validate?.regex)) {
          const regex = new RegExp(inputField.validate.regex[0])
          if (!regex.test(formPayload.get(key))) errors[key] = inputField.validate.regex[1]
        }

        formJson[key] = formPayload.get(key)
      }
      if (Object.keys(errors).length) {
        return (this.errors = errors)
      }
      this.init(formJson)
      /*       const emailRegex = /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/
      const nameRegex = /^([a-zA-ZáéíóúÁÉÍÓÚñÑ]{2,}[ ]?){1,}$/
      if (!nameRegex.test(this.name)) this.errorName = true
      if (!emailRegex.test(this.email)) this.errorEmail = true
      if (this.errorName || this.errorEmail) return
      this.init({ name: this.name, email: this.email }) */
    },
    resetError(type) {
      this.errors[type] = ''
      /*       if (type === 'name') this.errorName = false
      else if (type === 'email') this.errorEmail = false */
    }
  },
  mounted() {
    this.dataForm.forEach((input) => {
      this.errors[input.name] = ''
    })
  }
}
</script>

<style scoped>
body {
  background: #faf3ec;
  font-family: 'Roboto';
}
::-webkit-input-placeholder {
  /* Chrome/Opera/Safari */
  color: #748194;
}
::-moz-placeholder {
  /* Firefox 19+ */
  color: #748194;
}
:-ms-input-placeholder {
  /* IE 10+ */
  color: #748194;
}
:-moz-placeholder {
  /* Firefox 18- */
  color: #748194;
}
.container {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 100;
  background-color: rgba(0, 0, 0, 0.2);
  border-radius: 15px 15px 15px 15px;
}
.c1 {
  box-shadow: 0 0 10px grey;
  background-color: white;
  width: 300px;
  height: 500px;
  display: inline-block;
  border-radius: 15px 15px 15px 15px;
}

.c11 {
  background-image: url('https://i.pinimg.com/736x/b8/09/22/b80922f6ea2daaf36a6627378662803b--deck-of-cards-phone-wallpapers.jpg');
  background-size: 300px 400px;
  background-repeat: no-repeat;
  background-color: white;
  width: 300px;
  height: 400px;
  display: inline-block;
  position: absolute;
  z-index: 4;
  border-radius: 15px 15px 200px 200px;
}
#left,
#right {
  color: white;
  display: inline-block;
  width: 146px;
  height: 500px;
  background-color: white;
  cursor: pointer;
}
#left {
  border-radius: 15px 0px 0px 15px;
}
#right {
  border-radius: 15px 15px 15px 0px;
}
.s1class {
  color: #748194;
  position: absolute;
  bottom: 0;
  left: 63%;
  margin-left: -50%;
}
.s1class span,
.s2class span {
  display: block;
}
.su {
  font-size: 20px;
}
.s2class {
  color: #748194;
  position: absolute;
  bottom: 0;
  right: 63%;
  margin-right: -50%;
}
.mainhead {
  color: white;
  font-size: 24px;
  text-align: center;
  margin-top: 50px;
}
.mainp {
  color: white;
  font-size: 13px;
  text-align: center;
  margin-top: 10px;
}
.c2 {
  background-color: white;
  width: 300px;
  border-radius: 15px;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  display: inline-block;
  max-height: 500px;
  scroll-behavior: smooth;
  overflow-y: auto;
}
.form-input--container {
  position: relative;
  margin: 0 35px 30px;
}
.form-input {
  outline: none;
  position: relative;
  border: none;
  background: #f6f7f9;
  border-radius: 5px;
}
.inputError {
  border: 1px solid #d32f2f !important;
}
.text-error {
  color: #d32f2f;
}
.username {
  font-weight: bold;
  width: 200px;
  height: 35px;
  padding: 6px 15px;
  /* border-radius: 5px; */
  outline: none;
  border: none;
  /* background: #f6f7f9; */
  background: transparent;
  color: #748194;
  font-size: 14px;
}
.error {
  position: absolute;
  right: 0;
  margin-right: 0.5em;
  top: 50%;
  transform: translateY(-50%);
}
.btn {
  font-weight: bold;
  width: 230px;
  margin: 0 35px 3em;
  height: 45px;
  padding: 6px 15px;
  border-radius: 5px;
  outline: none;
  border: none;
  color: white;
  font-size: 14px;
}
.btn:hover {
  cursor: pointer;
}
.signup1 {
  font-size: 20px;
  margin: 2em 0;
  text-align: center;
}
a {
  text-decoration: none;
}
.signup2 {
  color: #748194;
  font-size: 20px;
  text-align: center;
}
.signup {
  display: initial;
}
.signin {
  display: initial;
}
.pre-icon {
  height: 100%;
  width: 20%;
  display: flex;
  justify-content: center;
  margin: 0;
  padding: 0;
  font-weight: bold;
}
.has-icon {
  display: flex;
  background: #f6f7f9;
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
  align-items: center;
}
.has-icon input {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
</style>
